import { RestError } from "../../services/rest-service/RestService";
import { useQuery } from "react-query";
import { RulesEngineRuleCustomerTypeEnum } from "../../common/enums/RulesEngineRuleCustomerTypeEnum";
import { RulesEngineRuleRunTypeEnum } from "../../common/enums/RulesEngineRuleRunTypeEnum";
import { RulesEngineRuleTypeEnum } from "../../common/enums/RulesEngineTypeEnum";
import { IRulesEngineRuleModel } from "../../services/rules-engine-data-service/Models";
import RulesEngineDataService from "../../services/rules-engine-data-service/RulesEngineDataService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";

export type UseRulesEngineRulesParameters = {
    ruleID?: number,
    ruleType?: RulesEngineRuleTypeEnum,
    runType?: RulesEngineRuleRunTypeEnum,
    customerType?: RulesEngineRuleCustomerTypeEnum
} & BaseUseQueryParameters<Array<IRulesEngineRuleModel>>

export function useRulesEngineRules({
    ruleID,
    ruleType,
    runType,
    customerType,
    enabled,
    onError,
    onSuccess,
    refreshSeconds
}: UseRulesEngineRulesParameters) {
    return useQuery<Array<IRulesEngineRuleModel>, RestError>(
        keys.rulesEngineRule(ruleID, ruleType, runType),
        ({ signal }) => {
            return RulesEngineDataService.getRulesEngineRules(ruleID, ruleType, runType, customerType, signal);
        },
        {
            enabled,
            onError: onError,
            onSuccess: onSuccess,
            refetchInterval: refreshSeconds ? refreshSeconds * 1000 : false
        }
    );
}